import React from 'react';
import Layout from '../Layout';
import ResetPassword from '../Forms/ResetPassword';

export default function SignUp() {
  return (
    <Layout>
      <ResetPassword />
    </Layout>
  );
}
